<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path
		d="M10 10.8332C10.4602 10.8332 10.8333 10.4601 10.8333 9.99984C10.8333 9.5396 10.4602 9.1665 10 9.1665C9.53977 9.1665 9.16667 9.5396 9.16667 9.99984C9.16667 10.4601 9.53977 10.8332 10 10.8332Z"
		stroke="#6C757D"
		stroke-width="1.5"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
	<path
		d="M15.8333 10.8332C16.2936 10.8332 16.6667 10.4601 16.6667 9.99984C16.6667 9.5396 16.2936 9.1665 15.8333 9.1665C15.3731 9.1665 15 9.5396 15 9.99984C15 10.4601 15.3731 10.8332 15.8333 10.8332Z"
		stroke="#6C757D"
		stroke-width="1.5"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
	<path
		d="M4.16666 10.8332C4.6269 10.8332 4.99999 10.4601 4.99999 9.99984C4.99999 9.5396 4.6269 9.1665 4.16666 9.1665C3.70642 9.1665 3.33333 9.5396 3.33333 9.99984C3.33333 10.4601 3.70642 10.8332 4.16666 10.8332Z"
		stroke="#6C757D"
		stroke-width="1.5"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
</svg>
